<template>
  <div class="header">
    <header>
      <div>
        <span @click="back" class="logo">GALAXYCIRCUS</span>
      </div>
      <div>
        <ul class="nav">

          <div class="a" @click="fun1" @mouseenter="yr1" @mouseleave="yc1">
            <li :class="{ active: is == 1 }" :style="{ background: background, color: color, transition: transition }">首页</li>
          </div>

          <div class="a" @click="fun2" @mouseenter="yr2" @mouseleave="yc2">
            <li :class="{ active: is == 2 }" :style="{ background: background1, color: color1, transition: transition }">教程</li>
          </div>

          <div class="a" @click="fun3" @mouseenter="yr3" @mouseleave="yc3">
            <li :class="{ active: is == 3 }" :style="{ background: background2, color: color2, transition: transition }">探寻</li>
          </div>

          <div class="a" @click="fun4" @mouseenter="yr4" @mouseleave="yc4">
            <li :class="{ active: is == 4 }" :style="{ background: background3, color: color3, transition: transition }">成果</li>
          </div>

          <div class="a" @click="fun5" @mouseenter="yr5" @mouseleave="yc5">
            <li :class="{ active: is == 5 }" :style="{ background: background4, color: color4, transition: transition }">关于</li>
          </div>

          <div class="b" @click="fun7" @mouseenter="yr7" @mouseleave="yc7">
            <li :class="{ active: is == 7 }" :style="{ background: background7, color: color6, transition: transition }">个人中心</li>
          </div>

          <div @click="jump">
            <li><el-switch v-model="value" active-text="中" inactive-text="英">
              </el-switch></li>
          </div>

          <!-- <div class="li"
               style="margin-right:35px">
            <li style="font-size:2em"
                @mouseenter="enter"
                @mouseout="out">···</li>
          </div> -->
          <!-- 媒体查询后的个人中心 -->
          <!-- <router-link style="text-decoration:none"
                       to="/home/my">
            <div @click="fun6"
                 @mouseenter="yr6"
                 @mouseleave="yc6"
                 class="center-one">
              <li :class="{active:is==6}"
                  :style="{background:background6,color:color5,transition:transition}"
                  style="font-size:1.9vw;">个人中心</li>
            </div>
          </router-link> -->

        </ul>
      </div>
    </header>

    <router-link style="text-decoration:none" to="/home/my">
      <div v-show="person" :style="{ background: background5 }" class="center">
        <span @mouseenter="my" @mouseout="zx">个人中心</span>
      </div>
    </router-link>

  </div>
</template>

<script>
export default {
  data () {
    return {
      // 个人中心显示隐藏
      person: false,
      xf: 0,
      is: 1,
      transition: "0.8s",
      background: "",
      background1: "",
      background2: "",
      background3: "",
      background4: "",
      // 个人中心的背景色
      background5: "",
      background6: "",
      background7: "",
      color: "#FFC300",
      color1: "",
      color2: "",
      color3: "",
      color4: "",
      color5: "",
      color6: "",
      timer: null,
      value: true
    }
  },
  mounted () {
    window.addEventListener('popstate', () => this.handleBack(), false)
    /*浏览器关闭、浏览器标签页关闭、浏览器刷新均会触发"beforeunload"事件*/
    window.addEventListener('beforeunload', e => this.handleFn(e))
  },
  created () {
    this.$bus.$on('openDemandList', () => {
      this.fun2()
    })

    this.$bus.$on('openDemandList1', () => {
      this.fun3()
    })

    this.$bus.$on('openDemandList2', () => {
      this.fun1()
    })
    this.handleFn()
  },
  methods: {
    // 监听刷新
    handleFn () {
      if (this.$route.path === "/home/first") {
        this.fun1()
      } else if (this.$route.path === "/home/tutorial") {
        this.fun2()
      } else if (this.$route.path === "/home/class") {
        this.fun3()
      } else if (this.$route.path === "/home/achievement") {
        this.fun4()
      } else if (this.$route.path === "/home/concerning") {
        this.fun5()
      } else if (this.$route.path === "/home/my") {
        this.fun7()
      }
    },
    back () {
      this.fun1()
    },
    // 监听浏览器返回
    handleBack () {
      if (this.$router.push("/home/first")) {
        this.fun1()
      } else if (this.$router.push("/home/tutorial")) {
        this.fun2()
      } else if (this.$router.push("/home/class")) {
        this.fun3()
      } else if (this.$router.push("/home/achievement")) {
        this.fun4()
      } else if (this.$router.push("/home/concerning")) {
        this.fun5()
      } else if (this.$router.push("/home/my")) {
        this.fun7()
      }
    },


    // 点击导航栏触发
    fun1 () {
      this.$router.push("/home/first")
      if (this.$route.path === "/home/first") {
        this.is = 1
      }
      this.xf = 1
      this.color1 = "white"
      this.color2 = "white"
      this.color3 = "white"
      this.color4 = "white"
      this.color5 = "white"
      this.color6 = "white"
    },
    // 移入导航栏触发
    yr1 () {
      // if (this.color == "white") {
      //   this.color = "white"
      // }
      // if (this.color == "red" && this.xf == 1) {
      //   this.color = "white"
      // }
      this.color = "white"
      this.background = "#FFC300"
    },
    // 移出导航栏触发
    yc1 () {
      if (this.xf == 1) {
        this.color = "#FFC300"
      }
      this.background = ""
    },

    fun2 () {
      this.$router.push("/home/tutorial")
      if (this.$route.path === "/home/tutorial") {
        this.is = 2
      }
      this.xf = 2
      this.color = "white"
      this.color2 = "white"
      this.color3 = "white"
      this.color4 = "white"
      this.color5 = "white"
      this.color6 = "white"
    },
    yr2 () {
      this.color1 = "white"
      this.background1 = "#FFC300"
    },
    yc2 () {
      if (this.xf == 2) {
        this.color1 = "#FFC300"
      }
      this.background1 = ""
    },

    fun3 () {
      this.$router.push("/home/class")
      if (this.$router.push("/home/class")) {
        this.is = 3
      }
      this.xf = 3
      this.color = "white"
      this.color1 = "white"
      this.color3 = "white"
      this.color4 = "white"
      this.color5 = "white"
      this.color6 = "white"
    },
    yr3 () {
      this.color2 = "white"
      this.background2 = "#FFC300"
    },
    yc3 () {
      if (this.xf == 3) {
        this.color2 = "#FFC300"
      }
      this.background2 = ""
    },

    fun4 () {
      this.$router.push("/home/achievement")
      if (this.$router.push("/home/achievement")) {
        this.is = 4
      }
      this.xf = 4
      this.color = "white"
      this.color2 = "white"
      this.color1 = "white"
      this.color4 = "white"
      this.color5 = "white"
      this.color6 = "white"
    },
    yr4 () {
      this.color3 = "white"
      this.background3 = "#FFC300"
    },
    yc4 () {
      if (this.xf == 4) {
        this.color3 = "#FFC300"
      }
      this.background3 = ""
    },

    fun5 () {
      this.$router.push("/home/concerning")
      if (this.$router.push("/home/concerning")) {
        this.is = 5
      }
      this.xf = 5
      this.color = "white"
      this.color1 = "white"
      this.color3 = "white"
      this.color2 = "white"
      this.color5 = "white"
      this.color6 = "white"
    },
    yr5 () {
      this.color4 = "white"
      this.background4 = "#FFC300"
    },
    yc5 () {
      if (this.xf == 5) {
        this.color4 = "#FFC300"
      }
      this.background4 = ""
    },

    fun6 () {
      // this.$router.push("/home/my")
      if (this.$router.push("/home/my")) {
        this.is = 6
      }
      this.xf = 6
      this.color = "white"
      this.color1 = "white"
      this.color3 = "white"
      this.color2 = "white"
      this.color4 = "white"
      this.color6 = "white"
    },
    yr6 () {
      this.color5 = "white"
      this.background6 = "#FFC300"
    },
    yc6 () {
      if (this.xf == 6) {
        this.color5 = "#FFC300"
      }
      this.background6 = ""
    },


    fun7 () {
      // this.$router.push("/home/my")
      if (this.$router.push("/home/my")) {
        this.is = 7
      }
      this.xf = 7
      this.color = "white"
      this.color1 = "white"
      this.color3 = "white"
      this.color2 = "white"
      this.color4 = "white"
      this.color5 = "white"
    },
    yr7 () {
      this.color6 = "white"
      this.background7 = "#FFC300"
    },
    yc7 () {
      if (this.xf == 7) {
        this.color6 = "#FFC300"
      }
      this.background7 = ""
    },

    // 移入···触发
    enter () {
      this.person = true
    },
    // 移出···触发
    out () {
      this.timer = setTimeout(() => {
        this.person = false
      }, 1000)
    },
    // 移入个人中心触发
    my () {
      clearTimeout(this.timer)
      this.timer = null
      this.background5 = "rgb(236,245,255)"
    },
    // 移出个人中心触发
    zx () {

      this.person = false
      this.background5 = ""
    },
    // 中英文切换
    jump () {
      window.location.href = "https://nadc.china-vo.org/galaxycircus/dist1-en/";
    }
  },
}
</script>

<style lang="scss" scoped>
// 头部
header {
  color: white;
  position: relative;
  left: 0%;
  top: 0%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 75px;
  background-color: black;
  padding-bottom: 1px;

  .logo {
    position: relative;
    font-size: 1.3rem;
    color: white;
    text-decoration: none;
    font-weight: 600;
    margin: 0 52px;
    cursor: pointer;
    /*悬停变小手的属性*/
  }

  .logo:hover {
    color: rgb(161, 162, 165);
  }

  .nav {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    li {
      display: inline-block;
      width: 100%;
      height: 105%;
      text-align: center;
      list-style: none;
      font-size: 1.3rem;
      padding: 0 35px;
      color: white;
      cursor: pointer;
      /*悬停变小手的属性*/
    }
  }

  .active {
    border-bottom: 2px solid #ffc300;
  }
}

.center {
  width: calc(30% - 150px);
  height: 5vh;
  background-color: rgb(255, 255, 255);
  text-align: center;
  position: relative;
  left: 80vw;
  z-index: 99;
  font-size: 1.3em;
  color: rgb(115, 156, 253);
  line-height: 5vh;
  border-radius: 1vh;
}

.center-one {
  display: none;
}

@media (max-width: 991px) {
  header {
    // 盒子一列展示
    flex-direction: column;
    line-height: 32px;
  }

  .center-one {
    display: block;
    margin-left: -10px;
    color: white;
  }

  .li {
    display: none;
  }
}
</style>